/* MERTRA — comportements maison (hero, carrousel de carte, ajout rapide) */
(function () {
  'use strict';

  /* ------------------------------------------------------------ panier */
  function cartDrawer() {
    return document.querySelector('m-cart-drawer');
  }

  function addToCart(items) {
    var drawer = cartDrawer();
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(res);
        } else {
          confirmer();
        }
        if (window.MinimogEvents && window.MinimogTheme) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, res);
        }
        refreshCount();
        return res;
      });
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-mtr-cart-count]').forEach(function (el) {
          el.textContent = c.item_count > 0 ? c.item_count : '';
        });
      });
  }

  /* ------------------------------------------------------------ confirmation d'ajout */
  var toast;
  function confirmer() {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mtr-toast';
      toast.innerHTML = '<span>Ajouté au panier</span><a href="/cart">Voir le panier</a>';
      document.body.appendChild(toast);
    }
    toast.classList.add('is-open');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-open'); }, 3200);
  }

  /* ------------------------------------------------------------ glissement horizontal */
  function glisser(el, cible) {
    var depart = el.scrollLeft;
    var delta = cible - depart;
    if (Math.abs(delta) < 2) return;
    var t0 = 0;
    var fini = false;
    setTimeout(function () { if (!fini) el.scrollLeft = cible; }, 360);
    function pas(ts) {
      if (!t0) t0 = ts;
      var k = Math.min((ts - t0) / 300, 1);
      var e = k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      el.scrollLeft = depart + delta * e;
      if (k < 1) requestAnimationFrame(pas);
      else { el.scrollLeft = cible; fini = true; }
    }
    requestAnimationFrame(pas);
  }

  /* ------------------------------------------------------------ hero */
  function initHero(root) {
    var slides = root.querySelectorAll('[data-mtr-hero-slide]');
    var dots = root.querySelectorAll('[data-mtr-hero-dot]');
    if (slides.length < 2) return;
    var i = 0;
    var speed = parseInt(root.dataset.mtrHeroSpeed || '5000', 10);

    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { go(k); });
    });
    if (root.dataset.mtrHeroAuto === 'true') {
      setInterval(function () { go(i + 1); }, speed);
    }
  }

  /* ------------------------------------------------------------ carte */
  function initCard(card) {
    var slides = card.querySelectorAll('[data-mtr-slide]');
    var dots = card.querySelectorAll('[data-mtr-dot]');
    var idx = 0;

    function go(n) {
      if (!slides.length) return;
      chargerDifferes();
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    // les visuels 2 a 4 n'ont pas d'URL tant que la carte n'a pas servi
    var differeFait = false;
    function chargerDifferes() {
      if (differeFait) return;
      differeFait = true;
      card.querySelectorAll('[data-mtr-differe]').forEach(function (im) {
        if (im.dataset.mtrDiffereSet) im.srcset = im.dataset.mtrDiffereSet;
        im.src = im.dataset.mtrDiffere;
        im.removeAttribute('data-mtr-differe');
      });
    }
    card.addEventListener('pointerenter', chargerDifferes, { once: true });
    card.addEventListener('touchstart', chargerDifferes, { once: true, passive: true });

    var prev = card.querySelector('[data-mtr-prev]');
    var next = card.querySelector('[data-mtr-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(idx + 1); });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(k); });
    });

    card.querySelectorAll('[data-mtr-size]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        btn.classList.add('is-loading');
        addToCart([{ id: Number(btn.dataset.mtrSize), quantity: 1 }])
          .catch(function () {})
          .then(function () { btn.classList.remove('is-loading'); });
      });
    });

    /* balayage au doigt */
    var shell = card.querySelector('.mtr-card__shell');
    if (shell && slides.length > 1) {
      var xDep = 0, yDep = 0, glisse = false;
      shell.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        xDep = e.touches[0].clientX;
        yDep = e.touches[0].clientY;
        glisse = false;
      }, { passive: true });

      shell.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 1) return;
        var dx = e.touches[0].clientX - xDep;
        var dy = e.touches[0].clientY - yDep;
        if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) glisse = true;
      }, { passive: true });

      shell.addEventListener('touchend', function (e) {
        if (!glisse) return;
        var dx = e.changedTouches[0].clientX - xDep;
        if (Math.abs(dx) < 40) { glisse = false; return; }
        go(dx < 0 ? idx + 1 : idx - 1);
        setTimeout(function () { glisse = false; }, 260);
      });

      /* un balayage ne doit pas ouvrir la fiche produit */
      shell.addEventListener('click', function (e) {
        if (glisse) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    var add = card.querySelector('[data-mtr-mobile-add]');
    if (add) {
      add.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSizeSheet(card);
      });
    }
  }

  /* ------------------------------------------------------------ panneau tailles mobile */
  var sheet, backdrop;
  function ensureSheet() {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.className = 'mtr-sizesheet__backdrop';
    sheet = document.createElement('div');
    sheet.className = 'mtr-sizesheet';
    sheet.innerHTML =
      '<div class="mtr-sizesheet__head"><span data-mtr-sheet-title>Choisir une taille</span>' +
      '<button type="button" class="mtr-sizesheet__close">[ Fermer ]</button></div>' +
      '<div class="mtr-sizesheet__row" data-mtr-sheet-row></div>';
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);
    function close() {
      sheet.classList.remove('is-open');
      backdrop.classList.remove('is-open');
    }
    backdrop.addEventListener('click', close);
    sheet.querySelector('.mtr-sizesheet__close').addEventListener('click', close);
  }

  function openSizeSheet(card) {
    ensureSheet();
    var row = sheet.querySelector('[data-mtr-sheet-row]');
    var title = sheet.querySelector('[data-mtr-sheet-title]');
    title.textContent = card.dataset.mtrTitle || 'Choisir une taille';
    row.innerHTML = '';
    card.querySelectorAll('[data-mtr-size]').forEach(function (btn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = btn.textContent.trim();
      b.disabled = btn.disabled;
      b.addEventListener('click', function () {
        b.disabled = true;
        addToCart([{ id: Number(btn.dataset.mtrSize), quantity: 1 }])
          .catch(function () {})
          .then(function () {
            sheet.classList.remove('is-open');
            backdrop.classList.remove('is-open');
          });
      });
      row.appendChild(b);
    });
    sheet.classList.add('is-open');
    backdrop.classList.add('is-open');
  }

  /* ------------------------------------------------------------ fiche produit */
  function initPdp(root) {
    var chips = root.querySelectorAll('[data-mtr-chip]');
    var partner = root.querySelectorAll('[data-mtr-partner]');
    var atc = root.querySelector('[data-mtr-atc]');
    var priceEl = root.querySelector('[data-mtr-price]');
    var chosen = null;
    var chosenPartner = null;

    function label() {
      if (!atc) return;
      if (!chosen) {
        atc.textContent = atc.dataset.mtrSelectLabel || 'CHOISIR UNE TAILLE';
        return;
      }
      atc.textContent = (atc.dataset.mtrAddLabel || 'AJOUTER') +
        (chosenPartner ? ' — ' + (atc.dataset.mtrSetLabel || 'LE SET') : '');
    }

    function majPrix() {
      if (!priceEl) return;
      var actif = root.querySelector('[data-mtr-chip].is-active');
      var val;
      if (chosenPartner) {
        val = (actif && actif.dataset.mtrChipPriceSet) || priceEl.dataset.mtrPriceSet;
      } else {
        val = (actif && actif.dataset.mtrChipPrice) || priceEl.dataset.mtrPriceBase;
      }
      if (val) priceEl.innerHTML = val;
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.disabled) return;
        chips.forEach(function (x) { x.classList.remove('is-active'); });
        c.classList.add('is-active');
        chosen = c.dataset.mtrChip;
        majPrix();
        label();
      });
    });

    partner.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.disabled) return;
        var was = c.classList.contains('is-active');
        partner.forEach(function (x) { x.classList.remove('is-active'); });
        if (was) {
          chosenPartner = null;
        } else {
          c.classList.add('is-active');
          chosenPartner = c.dataset.mtrPartner;
        }
        majPrix();
        label();
      });
    });

    if (atc) {
      atc.addEventListener('click', function () {
        if (!chosen) {
          var first = root.querySelector('[data-mtr-chip]:not([disabled])');
          if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return;
        }
        var items = [{ id: Number(chosen), quantity: 1 }];
        if (chosenPartner) items.push({ id: Number(chosenPartner), quantity: 1 });
        atc.disabled = true;
        addToCart(items).catch(function () {}).then(function () { atc.disabled = false; });
      });
    }

    /* galerie mobile : visuel + bande de miniatures */
    var mMedia = root.querySelector('[data-mtr-mobile-media]');
    var mThumbs = root.querySelectorAll('[data-mtr-mobile-thumb]');
    if (mMedia && mThumbs.length) {
      var mSlides = mMedia.querySelectorAll('[data-mtr-mobile-slide]');
      mThumbs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          if (!mSlides[k]) return;
          glisser(mMedia, mSlides[k].offsetLeft - mMedia.offsetLeft);
          mThumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
      var tick;
      mMedia.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var w = mMedia.clientWidth || 1;
          var i = Math.round(mMedia.scrollLeft / w);
          mThumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
          var actif = mThumbs[i];
          if (actif) {
            var g = actif.offsetLeft - mMedia.clientWidth / 2 + actif.clientWidth / 2;
            glisser(actif.parentNode, Math.max(0, g));
          }
        }, 90);
      }, { passive: true });
    }

    var thumbs = root.querySelectorAll('[data-mtr-thumb]');
    var medias = root.querySelectorAll('[data-mtr-media]');
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (medias[k]) medias[k].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  /* ------------------------------------------------------------ avis */
  function initAvis(root) {
    var piste = root.querySelector('[data-mtr-avis-piste]');
    var prec = root.querySelector('[data-mtr-avis-prec]');
    var suiv = root.querySelector('[data-mtr-avis-suiv]');
    if (piste && (prec || suiv)) {
      var pas = function () {
        var c = piste.querySelector('.mtr-avis__carte');
        return c ? c.getBoundingClientRect().width + 12 : 320;
      };
      if (prec) prec.addEventListener('click', function () { glisser(piste, piste.scrollLeft - pas()); });
      if (suiv) suiv.addEventListener('click', function () { glisser(piste, piste.scrollLeft + pas()); });
    }
    var btn = root.querySelector('[data-mtr-avis-plus]');
    if (!btn) return;
    var pas = parseInt(root.dataset.mtrAvisPas || '6', 10);
    btn.addEventListener('click', function () {
      var caches = root.querySelectorAll('[data-mtr-avis-cache]');
      for (var i = 0; i < pas && i < caches.length; i++) {
        caches[i].hidden = false;
        caches[i].removeAttribute('data-mtr-avis-cache');
      }
      if (!root.querySelector('[data-mtr-avis-cache]')) btn.parentNode.remove();
    });
  }

  /* ------------------------------------------------------------ recherche */
  function initRecherche() {
    var boite = document.querySelector('[data-mtr-recherche]');
    if (!boite) return;
    var champ = boite.querySelector('[data-mtr-recherche-champ]');
    var liste = boite.querySelector('[data-mtr-recherche-liste]');
    var etat = boite.querySelector('[data-mtr-recherche-etat]');
    var tout = boite.querySelector('[data-mtr-recherche-tout]');
    var minuteur;

    function ouvrir() {
      boite.hidden = false;
      boite.setAttribute('aria-hidden', 'false');
      setTimeout(function () { boite.classList.add('est-ouverte'); }, 12);
      setTimeout(function () { champ.focus(); }, 120);
    }
    function fermer() {
      boite.classList.remove('est-ouverte');
      boite.setAttribute('aria-hidden', 'true');
      setTimeout(function () { boite.hidden = true; }, 260);
    }

    document.querySelectorAll('[data-mtr-search-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); ouvrir(); });
    });
    boite.querySelectorAll('[data-mtr-recherche-fermer]').forEach(function (el) {
      el.addEventListener('click', fermer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !boite.hidden) fermer();
    });

    function afficher(produits, q) {
      liste.innerHTML = '';
      if (!produits.length) {
        etat.hidden = false;
        etat.textContent = 'Aucun résultat pour « ' + q + ' »';
        tout.hidden = true;
        return;
      }
      etat.hidden = true;
      produits.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'mtr-recherche__item';
        a.href = p.url;
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        a.innerHTML =
          (img ? '<img src="' + img + '&width=300" alt="" loading="lazy">' : '') +
          '<span class="mtr-recherche__nom">' + p.title + '</span>';
        liste.appendChild(a);
      });
      tout.hidden = false;
      tout.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
    }

    champ.addEventListener('input', function () {
      var q = champ.value.trim();
      clearTimeout(minuteur);
      if (q.length < 2) {
        liste.innerHTML = '';
        etat.hidden = true;
        tout.hidden = true;
        return;
      }
      minuteur = setTimeout(function () {
        etat.hidden = false;
        etat.textContent = 'Recherche…';
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
              { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var p = (d.resources && d.resources.results && d.resources.results.products) || [];
            afficher(p, q);
          })
          .catch(function () {
            etat.hidden = false;
            etat.textContent = 'Recherche indisponible, réessaie.';
          });
      }, 220);
    });
  }

  /* ------------------------------------------------------------ divers */
  function initChrome() {
    var burger = document.querySelector('[data-mtr-burger]');
    var drawer = document.querySelector('[data-mtr-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', function () { drawer.classList.add('is-open'); });
      var close = drawer.querySelector('[data-mtr-drawer-close]');
      if (close) close.addEventListener('click', function () { drawer.classList.remove('is-open'); });
    }
    var help = document.querySelector('[data-mtr-help]');
    var panel = document.querySelector('[data-mtr-help-panel]');
    if (help && panel) {
      help.addEventListener('click', function () { panel.classList.toggle('is-open'); });
    }
    document.querySelectorAll('[data-mtr-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var d = cartDrawer();
        if (d && typeof d.open === 'function') { e.preventDefault(); d.open(); }
      });
    });
    
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mtr-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-mtr-card]').forEach(function (c) {
      if (c.dataset.mtrReady) return;
      c.dataset.mtrReady = '1';
      initCard(c);
    });
    (scope || document).querySelectorAll('[data-mtr-pdp]').forEach(initPdp);
    (scope || document).querySelectorAll('[data-mtr-avis]').forEach(initAvis);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot();
    initChrome();
    initRecherche();
    refreshCount();
  });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  window.MertraBoot = boot;
})();
